export class Auditor {
  id?: number;
  fullName: string;
  fullNameEn: string;
  userNumber: string;
  department: string;
  auditorType: string;
  allowToEdit: boolean;
  subjects: string;
}
